import { useQuery } from 'react-query';
import { getIsPasswordTokenValid } from '../../api/password';

export const useIsPasswordTokenValid = (token: string) => {
  return useQuery('user', () => getIsPasswordTokenValid(token), {
    refetchOnWindowFocus: false,
    retry: false,
  });
};
